import React, { useMemo } from "react";
import { StyleSheet, View, Image, Text } from "react-native";
import Icon from "react-native-vector-icons/Feather";
import { NavLink } from "react-router-dom";
import { matchPath, withRouter } from "react-router";

import palette from "~/styles/palette";

const IconNavLink = withRouter(
  ({ to, match, iconName = "", badge, vertical, bgOverride = null }) => {
    const isMatch = matchPath(match.url, {
      path: to,
      exact: false,
      strict: false,
    });

    const backgroundColor = useMemo(() => {
      if (bgOverride) {
        return bgOverride;
      }

      return isMatch ? palette.primary : palette.primary_dark;
    }, [isMatch, bgOverride]);

    return (
      <View
        style={{
          width: vertical ? "100%" : null,
          marginRight: vertical ? 0 : 20,
          height: vertical ? 95 : 38,
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          backgroundColor,
          borderLeftColor: isMatch ? palette.success : palette.primary_dark,
          borderLeftWidth: 5,
        }}
      >
        <NavLink
          to={to}
          style={{
            textDecoration: "none",
            position: "relative",
          }}
          activeStyle={{
            color: palette.success,
          }}
        >
          <Icon
            name={iconName}
            size={32}
            color={(isMatch || bgOverride) ? palette.white : palette.grey}
          />
          {(badge || badge == 0) && <IconBadge count={badge} />}
        </NavLink>
      </View>
    );
  }
);

const IconBadge = ({ count }) => (
  <>
    {!count ? null : (
      <View style={[styles.icon_nav_link__badge_container]}>
        <Text style={[styles.icon_nav_link__badge_text]}>{count}</Text>
      </View>
    )}
  </>
);

const styles = StyleSheet.create({
  icon_nav_link__badge_container: {
    borderRadius: 20,
    maxHeight: 20,
    backgroundColor: palette.success,
    position: "absolute",
    bottom: -18,
    right: -5,
    minWidth: 22,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    paddingVertical: 6,
  },
  icon_nav_link__badge_text: {
    color: palette.primary,
    fontSize: 14,
    fontWeight: "700",
  },
});

export default IconNavLink;
